import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';

@doc.path('/partnership_statuses/{?id}')
abstract class AbstractPartnershipStatusModel extends WebsiteServiceModel {
	declare protected _tsFilters: {
		partial: string;
	};

	@doc.string declare name: Website_PartnershipStatusReference;
	@doc.number declare value: id;
	@doc.string declare label: string;
	@doc.string declare reference: Website_PartnershipStatusReference;
}

export default AbstractPartnershipStatusModel;
